import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Pages
import HomePage from "@/pages/HomePage";
import RevenueManagementPage from "@/pages/RevenueManagementPage";
import SoftwareRMSPage from "@/pages/SoftwareRMSPage";
import PricingDinamicoPage from "@/pages/PricingDinamicoPage";
import ForecastingPage from "@/pages/ForecastingPage";
import RevparPage from "@/pages/RevparPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import NotFoundPage from "@/pages/NotFoundPage";

// Scroll to top on route change and handle hash navigation
function ScrollHandler() {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  
  return null;
}

function AppContent() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/revenue-management-hoteles" element={<RevenueManagementPage />} />
          <Route path="/software-rms" element={<SoftwareRMSPage />} />
          <Route path="/pricing-dinamico" element={<PricingDinamicoPage />} />
          <Route path="/forecasting-hotelero" element={<ForecastingPage />} />
          <Route path="/revpar" element={<RevparPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollHandler />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
